import React, { useMemo, useState } from "react";
import { resolveActiveEmployee } from "../../Shared/ScreenUtils.jsx";
import { Sidebar } from "./Sidebar.jsx";
import { Topbar } from "./Topbar.jsx";
import { SessionBars } from "./SessionBars.jsx";
import { buildNav, pageTitle, sectionFor } from "./navigation.js";
import { useNavFlags } from "./useNavFlags.js";

// The frame around every signed-in page: the menu on the left, the bar on top and the page in the middle.
export function AppShell({ children, route, navigate, data, loading, errors, reload }) {
  const activePath = route.split("?")[0];
  const [menuOpen, setMenuOpen] = useState(false);
  const flags = useNavFlags(data);
  const nav = useMemo(() => buildNav(data.me, flags), [data.me, flags.activeDelay, flags.integrationsDown, flags.idsWaiting, flags.calendarReconnect]);

  const user = data.me?.user || data.me?.account || data.me || {};
  const employee = resolveActiveEmployee(data) || {};
  const name = employee.display_name || employee.displayName || user.fullName || user.full_name || user.username || "";

  return (
    <div className="Atg-App">
      <Sidebar
        nav={nav}
        activePath={activePath}
        company={data.me?.company}
        mobileOpen={menuOpen}
        onCloseMobile={() => setMenuOpen(false)}
        onNavigate={(path) => { setMenuOpen(false); navigate(path); }}
      />
      <main className="Atg-Main">
        <Topbar
          me={data.me}
          title={sectionFor(activePath, nav) || pageTitle(activePath)}
          name={String(name)}
          profileActive={activePath.startsWith("/profile")}
          onProfile={() => navigate("/profile/")}
          loading={loading}
          errors={errors}
          notifications={data.notifications || []}
          navigate={navigate}
          reload={reload}
          onOpenMenu={() => setMenuOpen(true)}
        />
        <SessionBars me={data.me} errors={errors} />
        <div className="Atg-Content">{children}</div>
      </main>
    </div>
  );
}
